import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.4725 19.5275C11.6126 19.6676 11.8019 19.7474 12 19.75C12.1981 19.7474 12.3874 19.6676 12.5275 19.5275C12.6676 19.3874 12.7474 19.1981 12.75 19V6.81L17.47 11.53C17.5392 11.6001 17.6218 11.6557 17.7128 11.6935C17.8038 11.7312 17.9015 11.7505 18 11.75C18.0985 11.7505 18.1962 11.7312 18.2872 11.6935C18.3782 11.6557 18.4608 11.6001 18.53 11.53C18.6705 11.3894 18.7493 11.1987 18.7493 11C18.7493 10.8012 18.6705 10.6106 18.53 10.47L12.5487 4.48867C12.5427 4.48224 12.5366 4.47591 12.5303 4.46967C12.3897 4.32902 12.1989 4.25 12 4.25C11.8011 4.25 11.6103 4.32902 11.4697 4.46967C11.4634 4.4759 11.4573 4.48222 11.4514 4.48864L5.47 10.47C5.33752 10.6122 5.2654 10.8002 5.26882 10.9945C5.27225 11.1888 5.35096 11.3742 5.48838 11.5116C5.62579 11.649 5.81118 11.7277 6.00548 11.7312C6.19978 11.7346 6.38782 11.6625 6.53 11.53L11.25 6.81V19C11.2526 19.1981 11.3324 19.3874 11.4725 19.5275Z",
      fill: "#212121"
    }, null, -1)
  ])))
}
export default { render: render }